(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/components/ticket-order-counter.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/components/ticket-order-counter.js');
"use strict";


const Icon = svs.ui.ReactIcon;
const IconButton = svs.ui.ReactIconButton;
const formatCurrency = svs.utils.format.Currency;
const TicketOrderCounter = _ref => {
  let className = _ref.className,
    count = _ref.count,
    onDecrement = _ref.onDecrement,
    onIncrement = _ref.onIncrement,
    incrementDisabled = _ref.incrementDisabled,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '400' : _ref$size;
  return React.createElement("div", {
    className: "u-flex u-flex-justify-content-between u-flex-align-items-center ".concat(className ? className : '')
  }, React.createElement(IconButton, {
    "data-increment": -1,
    disabled: count <= 0,
    onClick: onDecrement
  }, React.createElement(Icon, {
    icon: "minus",
    size: size
  })), React.createElement("span", {
    className: "f-800 fw-500",
    "data-testid": "ticket-order-count"
  }, count), React.createElement(IconButton, {
    "data-increment": 1,
    disabled: incrementDisabled,
    onClick: onIncrement
  }, React.createElement(Icon, {
    icon: "plus",
    size: size
  })));
};
const TicketOrderCounterWithPrice = _ref2 => {
  let className = _ref2.className,
    count = _ref2.count,
    totalPrice = _ref2.totalPrice,
    incrementDisabled = _ref2.incrementDisabled,
    onDecrement = _ref2.onDecrement,
    onIncrement = _ref2.onIncrement;
  const price = "".concat(formatCurrency(totalPrice), " kr");
  return React.createElement("div", null, React.createElement("div", {
    className: "u-flex ".concat(className ? className : '')
  }, React.createElement(TicketOrderCounter, {
    className: "flex-1",
    count: count,
    incrementDisabled: incrementDisabled,
    onDecrement: onDecrement,
    onIncrement: onIncrement
  }), React.createElement("div", {
    className: "u-flex flex-1 u-flex-align-items-center u-flex-justify-content-end f-content"
  }, React.createElement("div", null, "Pris:", React.createElement("span", {
    className: "f-800 fw-500",
    style: {
      marginLeft: '3px'
    }
  }, price)))), incrementDisabled && React.createElement("div", {
    className: "u-flex padding-top-1"
  }, React.createElement(Icon, {
    className: "margin-right-half",
    icon: "exclamation-sign",
    size: "400"
  }), React.createElement("p", {
    className: "margin-bottom-0"
  }, "Oj, nu blev det fullt i kuvertet! Du kan inte l\xE4gga till fler av denna lott i best\xE4llningen.")));
};
setGlobal('svs.ticketsOrderHome.components.TicketOrderCount', TicketOrderCounter);
setGlobal('svs.ticketsOrderHome.components.TicketOrderCounterWithPrice', TicketOrderCounterWithPrice);

 })(window);